import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const navbarRef = useRef(null);

  const handleNav = () => {
    setNav(!nav);
  };

  // Function to handle click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setNav(false); // Close the navbar when clicking outside
      }
    }

    if (nav) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [nav]);

  return (
    <nav className='flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white'>
      <h1 className='w-full text-3xl font-bold text-[#00df9a]'>Cerberus Solution</h1>
      <ul className='hidden md:flex'>
        <li className='p-4'><Link to="/">Home</Link></li>
        <li className='p-4'><Link to="/Download">Download</Link></li>
        <li className='p-4'><Link to="/About">About</Link></li>
        <li className='p-4'><Link to="/Contact">Contact</Link></li>
      </ul>
      <div onClick={handleNav} className='block md:hidden cursor-pointer'>
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>
      {/* Mobile Menu */}
      <ul
        ref={navbarRef}
        className={nav ? 'fixed z-50 left-0 top-0 w-[33%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500' : 'fixed left-[-100%] ease-in-out duration-500'}
      >
        <h2 className='w-full text-2xl font-bold text-[#00df9a] m-4'>Cerberus Solution</h2>
        <li className='p-4 border-b border-gray-600'><Link to="/" onClick={handleNav}>Home</Link></li>
        <li className='p-4 border-b border-gray-600'><Link to="/Download" onClick={handleNav}>Download</Link></li>
        <li className='p-4 border-b border-gray-600'><Link to="/About" onClick={handleNav}>About</Link></li>
        <li className='p-4'><Link to="/Contact" onClick={handleNav}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;